var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container app-h100",staticStyle:{"opacity":"0"}},[_c('h1',[_vm._v("placeholder")]),_c('input',{ref:"input",attrs:{"type":"text"}})])}
var staticRenderFns = []

export { render, staticRenderFns }